/**
 * "Slett annonse": a seller's deleted listing.
 *
 * Sharetribe only lets a seller delete a draft. A published listing is closed
 * instead and marked in its metadata, which the seller cannot change:
 *   metadata.deletedAt          ISO time of the deletion
 *   metadata.deleteReason       one of DELETE_REASONS
 *   metadata.deleteReasonText   the seller's own words with "Annet", if any
 *   metadata.stateBeforeDelete  the state it was in (published, closed, pendingApproval)
 * A listing waiting for approval can't be closed, so it is only marked.
 *
 * CommonJS, so the server (the delete endpoint, the admin jobs) reads the same
 * rule as the app.
 */

// The reasons a seller picks from, in the order the dialog lists them
// (Guro, 26 October). Older deletions may carry a reason no longer offered
// (e.g. 'ombestemt-meg'); /admin still names those.
const DELETE_REASONS = [
  'solgt-annet-sted',
  'onsker-a-beholde',
  'fikk-ikke-solgt',
  'opprette-pa-nytt',
  'annet',
];
// "Annet" comes with an optional text of the seller's own, at most this long.
const REASON_WITH_TEXT = 'annet';
const REASON_TEXT_MAX_LENGTH = 200;

/**
 * Whether the seller has deleted the listing. A listing reopened in Console
 * after a deletion is public again and counts as not deleted, whatever its
 * metadata still says.
 *
 * @param {Object} listing - listing or own listing entity
 * @returns {boolean}
 */
const isDeletedListing = listing =>
  !!listing?.attributes?.metadata?.deletedAt && listing.attributes.state !== 'published';

module.exports = { DELETE_REASONS, REASON_WITH_TEXT, REASON_TEXT_MAX_LENGTH, isDeletedListing };
